import { DEFAULT_LIST_SIZE as o } from "../../constants/layout.js";
import * as e from "yup";
const n = e.object({
  page: e.number().default(0),
  pageSize: e.number().default(o),
  total: e.number().default(0),
  totalPage: e.number().when(["total", "pageSize"], (t, r) => {
    const a = Math.ceil(t / r);
    return e.number().default(a);
  }).default(0),
  hasNextPage: e.boolean().default(!1),
  hasPreviousPage: e.boolean().default(!1)
}).from("totalCount", "total"), s = n.concat(
  e.object({
    previousCursor: e.string().when(["hasPreviousPage"], (t) => t ? e.string() : e.string().strip(!0)),
    nextCursor: e.string().when(["hasNextPage"], (t) => t ? e.string() : e.string().strip(!0))
  }).from("startCursor", "previousCursor").from("endCursor", "nextCursor")
), l = e.object({
  nextCursor: e.string().default(""),
  total: e.number().default(0)
});
export {
  n as pageInfoLiteSchema,
  s as pageInfoSchema,
  l as thirdPartyPageInfoSchema
};
//# sourceMappingURL=page.js.map
